// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.viewShowAttendee_dashboard__OubQU {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.viewShowAttendee_dashboardContain__YSuhA {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_dashboardContain__YSuhA,
.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_dashboard__OubQU,
.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_cont2__Y6PTs {
  background-Color: #0f1824;
}

.viewShowAttendee_top_header__hhkIX .viewShowAttendee_top_header_inner__QB2Wu {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.viewShowAttendee_cont2__Y6PTs {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.viewShowAttendee_subLink__kTzjV svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.viewShowAttendee_cst_vendr__GuivX input {
  min-height: 35px !important;
}

.viewShowAttendee_cst_vendr__GuivX .viewShowAttendee_form-control__PV8VC {
  background-color: #f5f6fa;
  border: none;
}

.viewShowAttendee_footer__XXOdA {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.viewShowAttendee_bodythemelight__SLZWi {
  background-color: #fff;
  padding-top: 90px;
}

.viewShowAttendee_bodythemedark__y67m- {
  background-color: #132337;
  padding-top: 90px;
}

.viewShowAttendee_bodythemeNew__PInKf {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.viewShowAttendee_headerthemelight__B0jZe {
  background-color: #fff;
}

.viewShowAttendee_headerthemedark__c\\+SVE {
  background-color: #132337;
}

.viewShowAttendee_top_header__hhkIX {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.viewShowAttendee_menuthemelight__MMk8D {
  background-color: #f5f6fa;
}

.viewShowAttendee_menuthemedark__T6l2Z {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.viewShowAttendee_menulinklight__tmm9z span {
  color: #666666 !important;
}

.viewShowAttendee_menulinklight__tmm9z a {
  color: #CBCBCB !important;
}

.viewShowAttendee_menulinklight__tmm9z:hover span,
.viewShowAttendee_menulinklight__tmm9z:hover a {
  color: #fff !important;
}

.viewShowAttendee_menulinkdarkSelected__BQgXI {
  background-color: #1c2e45;
  color: #3b82f6;
}

.viewShowAttendee_menuthemelight__MMk8D .viewShowAttendee_menulinklightSelected__pyfaJ {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.viewShowAttendee_menulinkdark__1C4Gn {
  color: #92afd3 !important;
}

.viewShowAttendee_menulinklight__tmm9z:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.viewShowAttendee_menulinklight__tmm9z .viewShowAttendee_sub_arrow__j3C48 svg path {
  stroke: #CBCBCB !important;
}

.viewShowAttendee_menulinklight__tmm9z:hover .viewShowAttendee_sub_arrow__j3C48 svg path {
  stroke: #fff !important;
}

.viewShowAttendee_menulinkdark__1C4Gn .viewShowAttendee_sub_arrow__j3C48 svg path {
  stroke: #92afd3 !important;
}

.viewShowAttendee_menulinkdark__1C4Gn:hover .viewShowAttendee_sub_arrow__j3C48 svg path {
  stroke: #fff !important;
}

.viewShowAttendee_menulinklight__tmm9z:hover svg path,
.viewShowAttendee_menulinklightSelected__pyfaJ svg path {
  fill: #fff !important;
}

.viewShowAttendee_menulinkdark__1C4Gn:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.viewShowAttendee_headinglight__rsVcY {
  color: #60677e;
}

.viewShowAttendee_headingdark__ZzRIh {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.viewShowAttendee_searchboxlight__POzdI {
  background-color: #fff;
  border: none;
}

.viewShowAttendee_searchboxdark__gS5qQ {
  background-color: #132337;
  color: #fff;
  border: none;
}

.viewShowAttendee_searchboxdark__gS5qQ::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.viewShowAttendee_tableheadlight__4BwEe {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.viewShowAttendee_tableheadlight__4BwEe th {
  color: #fff;
}

thead .viewShowAttendee_tableheadlight__4BwEe th:first-child,
thead .viewShowAttendee_tableheaddark__zX3vr th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .viewShowAttendee_tableheadlight__4BwEe th:last-child,
thead .viewShowAttendee_tableheaddark__zX3vr th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.viewShowAttendee_table__uMnnr.viewShowAttendee_table-borderless__jLig5 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.viewShowAttendee_tableheaddark__zX3vr {
  background-color: #132337;
  color: #fff;
}

.viewShowAttendee_table-borderless__jLig5 tr:nth-child(even) {
  background-color: #F9FAFB;
}

.viewShowAttendee_table-borderless__jLig5 .viewShowAttendee_left-section__4oRWs {
  padding-top: 10px;
}

.viewShowAttendee_tablebodylight__BxXi1 td,
.viewShowAttendee_tablebodydark__lFMm8 td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.viewShowAttendee_tablebodylight__BxXi1 {
  background-color: #fff;
}
.viewShowAttendee_tablebodylight__BxXi1:hover {
  background-color: #fff;
  cursor: auto;
}
.viewShowAttendee_tablebodylight__BxXi1 p {
  line-height: 24px;
}

.viewShowAttendee_tablebodydark__lFMm8 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.viewShowAttendee_tablebodydark__lFMm8:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.viewShowAttendee_paginationlight__CN8Nx {
  color: #60677e !important;
  font-size: 13px !important;
}

.viewShowAttendee_paginationdark__q2zsX {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.viewShowAttendee_formthemelight__nxrtL {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.viewShowAttendee_formthemedark__ykxKM {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.viewShowAttendee_formthemedark__ykxKM ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.viewShowAttendee_viewformlight__PWXwx {
  background-color: #f3f6f9;
}

.viewShowAttendee_permissionboxlight__N1XXM {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.viewShowAttendee_permissionboxdark__uJeAt {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.viewShowAttendee_errormsgclr__zmwB8 {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.viewShowAttendee_graphclrlight__tRzXZ {
  background-color: #fff;
}

.viewShowAttendee_graphclrdark__3oRPz {
  background-color: #132337;
}

/* 
Counter theme
*/
#viewShowAttendee_card1bglight__WWivJ {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#viewShowAttendee_card1bgdark__2Npk4 {
  background: #392f28;
}

#viewShowAttendee_card2bglight__YBBy3 {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#viewShowAttendee_card2bgdark__EXlv\\+ {
  background: #1c3238;
}

#viewShowAttendee_card3bglight__Bqb3D {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#viewShowAttendee_card3bgdark__Oljbx {
  background: #3a2434;
}

#viewShowAttendee_card4bglight__Vr2co {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#viewShowAttendee_card4bgdark__uYbgd {
  background: #2f264f;
}

#viewShowAttendee_card1bgdark__2Npk4 a,
#viewShowAttendee_card1bgdark__2Npk4 p,
#viewShowAttendee_card2bgdark__EXlv\\+ a,
#viewShowAttendee_card2bgdark__EXlv\\+ p,
#viewShowAttendee_card3bgdark__Oljbx a,
#viewShowAttendee_card3bgdark__Oljbx p,
#viewShowAttendee_card4bgdark__uYbgd a,
#viewShowAttendee_card4bgdark__uYbgd p {
  color: #fff;
}

/* 
Action button theme
*/
.viewShowAttendee_actionbtnlight__wU1jy {
  color: rgba(70, 71, 91, 0.8705882353);
}

.viewShowAttendee_actionbtndark__oWKf3 {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.viewShowAttendee_profiledropdownlight__qyYdY {
  background-color: #fff;
}

.viewShowAttendee_profiledropdowndark__sVogl {
  background-color: #151521;
}

.viewShowAttendee_settingsection__UmfF7 #viewShowAttendee_addform__iQw0O.viewShowAttendee_formthemedark__ykxKM .viewShowAttendee_savebtn__G281V {
  background-color: #3b82f6;
  color: #fff;
}

#viewShowAttendee_addform__iQw0O.viewShowAttendee_formthemedark__ykxKM .viewShowAttendee_savebtn__G281V {
  background-color: #3b82f6;
  color: #fff;
}

.viewShowAttendee_profile_conatiner__6lyeu {
  border-radius: 5px !important;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_ag-theme-alpine__b5xZt .viewShowAttendee_ag-row__nGEJd {
  background: #000 !important;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_formbtn__3V50I {
  background-color: #3b82f6;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_formbtn__3V50I:hover {
  background-color: #2563eb;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_resetbtn__4EdCc {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_resetbtn__4EdCc:hover {
  background-color: #3b82f6;
}

.viewShowAttendee_headingdark__ZzRIh span {
  background-color: #132337;
}

.viewShowAttendee_resetbtn__4EdCc {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.viewShowAttendee_resetbtn__4EdCc:hover,
.viewShowAttendee_resetbtn__4EdCc:active,
.viewShowAttendee_resetbtn__4EdCc:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.viewShowAttendee_addBtn__lGgV1 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewShowAttendee_addDltBtn__rAMSG {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewShowAttendee_addbtnlight__Jztmm {
  background-color: #38A169;
}

.viewShowAttendee_addbtndark__qSriy {
  background-color: #3b82f6;
}

.viewShowAttendee_addbtndark__qSriy:hover {
  background-color: #2563eb;
}

.viewShowAttendee_formthemedark__ykxKM label {
  color: #92afd3;
}

.viewShowAttendee_addBtn__lGgV1 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.viewShowAttendee_addBtn__lGgV1:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.viewShowAttendee_cust_addBtn__7GBuy.viewShowAttendee_addBtn__lGgV1 svg {
  top: 2px;
}

.viewShowAttendee_deleteBtn__yFSe8 {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.viewShowAttendee_deleteBtn__yFSe8 {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.viewShowAttendee_deleteBtn__yFSe8:active,
.viewShowAttendee_deleteBtn__yFSe8:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.viewShowAttendee_deleteBtn__yFSe8 svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.viewShowAttendee_deleteBtn__yFSe8:hover,
.viewShowAttendee_deleteBtn__yFSe8:active,
.viewShowAttendee_deleteBtn__yFSe8:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.viewShowAttendee_confirmBtn__iK\\+be {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.viewShowAttendee_confirmBtn__iK\\+be:hover,
.viewShowAttendee_confirmBtn__iK\\+be:active,
.viewShowAttendee_confirmBtn__iK\\+be:focus {
  background-color: #0f1824 !important;
}

.viewShowAttendee_confirmBtn__iK\\+be svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.viewShowAttendee_delPopContainer__mQrXD .viewShowAttendee_modal-body__cynrs {
  padding: 35px;
  text-align: center;
}

.viewShowAttendee_delPopContainer__mQrXD .viewShowAttendee_delet_icon__D8Q0f {
  margin-bottom: 11px;
}

.viewShowAttendee_delPopContainer__mQrXD p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.viewShowAttendee_arrowback__r0c6F svg {
  fill: #000;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_arrowback__r0c6F {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_arrowback__r0c6F svg {
  fill: #3b82f6;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_drpdwn_btn__opyvB {
  background-color: #132337;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_empname__owAlU {
  color: #92afd3 !important;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_navitemli__Mpdhb a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_tabnavli__S9HvC a.viewShowAttendee_settingsgeneral__QHE2i,
.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_tabnavli__S9HvC a.viewShowAttendee_settingslinks__qAudI:hover {
  background-color: #3b82f6;
  color: #fff;
}

.viewShowAttendee_bodythemedark__y67m- .viewShowAttendee_tabnavli__S9HvC a.viewShowAttendee_settingslinks__qAudI {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewShowAttendee_headerthemedark__c\\+SVE .viewShowAttendee_dropdown_menu_contain__lvU5r {
  background-color: #1c2e45;
  color: #fff;
}

.viewShowAttendee_headerthemedark__c\\+SVE .viewShowAttendee_dropdown_menu_contain__lvU5r ul li a,
.viewShowAttendee_headerthemedark__c\\+SVE .viewShowAttendee_dropdown_menu_contain__lvU5r .viewShowAttendee_dropdown_item__gaxol,
.viewShowAttendee_headerthemedark__c\\+SVE .viewShowAttendee_dropdown_menu_contain__lvU5r .viewShowAttendee_dropdown_item__gaxol h5 {
  color: #fff;
}

.viewShowAttendee_headerthemedark__c\\+SVE .viewShowAttendee_dropdown_menu_contain__lvU5r ul li a:hover,
.viewShowAttendee_headerthemedark__c\\+SVE .viewShowAttendee_dropdown_menu_contain__lvU5r .viewShowAttendee_dropdown_item__gaxol:hover {
  background-color: #132337;
  color: #fff;
}

.viewShowAttendee_dropdown_item__gaxol:active {
  background-color: #F5F6FA;
}

.viewShowAttendee_profile_arrrow_dwn__0Wof1 {
  stroke: #132337;
}

.viewShowAttendee_headerthemedark__c\\+SVE .viewShowAttendee_profile_arrrow_dwn__0Wof1 {
  stroke: #fff;
}

.viewShowAttendee_dateinputbox1__9ob4k input,
.viewShowAttendee_dateinputbox1__9ob4k span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.viewShowAttendee_delPopContainer__mQrXD .viewShowAttendee_modal-content__V\\+FXL {
  border-radius: 10px;
  min-width: 399px;
}

.viewShowAttendee_larg_model__YSDn3 .viewShowAttendee_modal-dialog__4px-z {
  max-width: 100% !important;
}

.viewShowAttendee_larg_model__YSDn3 .viewShowAttendee_modal-content__V\\+FXL {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.viewShowAttendee_larg_model__YSDn3 .viewShowAttendee_modal-header__qPxNN {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .viewShowAttendee_btn-primary__oFnhs:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.viewShowAttendee_form-select__ViUc9 {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .viewShowAttendee_CustomTable_tableheadlight__HuHZw__SVAHo th:first-child,
thead .viewShowAttendee_CustomTable_tableheaddark__nwqb4__YVhg9 th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .viewShowAttendee_tableheadlight__4BwEe th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .viewShowAttendee_dashboard__OubQU {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .viewShowAttendee_cont2__Y6PTs {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .viewShowAttendee_sectionright__MGMNH {
    float: unset !important;
  }
  .viewShowAttendee_dashboard__OubQU {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .viewShowAttendee_cont2__Y6PTs {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .viewShowAttendee_bodythemelight__SLZWi,
.viewShowAttendee_bodythemedark__y67m- {
    padding-top: 110px;
  }
  .viewShowAttendee_delPopContainer__mQrXD .viewShowAttendee_modal-content__V\\+FXL {
    min-width: 100%;
  }
  .viewShowAttendee_delPopContainer__mQrXD .viewShowAttendee_modal-body__cynrs {
    padding: 15px;
  }
  .viewShowAttendee_larg_model__YSDn3 .viewShowAttendee_modal-content__V\\+FXL {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .viewShowAttendee_exer_modal_contain__Aqb1m .viewShowAttendee_modal-dialog__4px-z {
    max-width: 1055px;
  }
  .viewShowAttendee_delPopContainer__mQrXD .viewShowAttendee_modal-dialog__4px-z {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.viewShowAttendee_active_show_outer__L0WCQ h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .viewShowAttendee_active_show_outer__L0WCQ h2 {
    margin-top: 15px;
  }
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA {
  width: 100%;
  display: block;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_img__Hd3xs {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_img__Hd3xs {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_img__Hd3xs img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX {
  width: 100%;
  display: block;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX svg {
  flex-shrink: 0;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX .viewShowAttendee_act_box_bdg__RZokO {
  width: 100%;
  margin-bottom: 12px;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX .viewShowAttendee_act_box_bdg__RZokO span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX .viewShowAttendee_act_box_bdg__RZokO .viewShowAttendee_sold__-BMAE {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.viewShowAttendee_active_show_outer__L0WCQ .viewShowAttendee_active_show_inner__8YWmA .viewShowAttendee_act_box_cnt__0kKBX p .viewShowAttendee_timezone_code_pill__7KoAw {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#viewShowAttendee_attent_details_row1__EvLDo {
  margin-bottom: 0 !important;
}

.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_l__uJDA3 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK {
  flex: 1 1;
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row__Fr23I {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row__Fr23I {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row__Fr23I .viewShowAttendee_attent_details_row_box__tgf6U {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row__Fr23I .viewShowAttendee_attent_details_row_box__tgf6U {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row__Fr23I .viewShowAttendee_attent_details_row_box__tgf6U {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row__Fr23I .viewShowAttendee_attent_details_row_box__tgf6U p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row__Fr23I .viewShowAttendee_attent_details_row_box__tgf6U h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row_last__rQlip {
  margin-bottom: 0px !important;
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row_last__rQlip.viewShowAttendee_interesting_fact__4vT9h {
  padding-top: 30px;
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row_last__rQlip.viewShowAttendee_interesting_fact__4vT9h .viewShowAttendee_attent_details_row_box__tgf6U {
  width: 100%;
}
.viewShowAttendee_attent_details__3qH0V .viewShowAttendee_attent_details_inner__GPV1e .viewShowAttendee_attent_details_inner_r__yKnJK .viewShowAttendee_attent_details_row_last__rQlip.viewShowAttendee_interesting_fact__4vT9h .viewShowAttendee_attent_details_row_box__tgf6U h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.viewShowAttendee_showbox_sec__GLDuz {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .viewShowAttendee_showbox_sec__GLDuz {
    justify-content: center;
  }
}

.viewShowAttendee_show_box_main__hpyFI {
  margin: 10px 0px;
}
.viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_show_box__IhquG {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_show_box__IhquG {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_show_box__IhquG {
    min-height: 500px;
    width: 200px !important;
  }
}
.viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_show_box__IhquG img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_show_box__IhquG img {
    max-height: 300px !important;
  }
}
.viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_show_box__IhquG:last-child {
  margin-right: 0px !important;
}
.viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_no_show_box__1n0lz {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_no_show_box__1n0lz {
    width: 250px !important;
  }
}
.viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_no_show_box__1n0lz img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_no_show_box__1n0lz img {
    max-height: 350px !important;
  }
}
.viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_no_show_box__1n0lz h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .viewShowAttendee_show_box_main__hpyFI .viewShowAttendee_no_show_box__1n0lz h6 {
    font-size: 20px;
  }
}

.viewShowAttendee_attent_flex__9i9cQ {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.viewShowAttendee_attent_flex__9i9cQ h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.viewShowAttendee_indexdiv__j9uA6 #viewShowAttendee_addheading__Vbo81 {
  font-size: 18px;
  margin-bottom: 20px;
}
.viewShowAttendee_indexdiv__j9uA6 .viewShowAttendee_exportsection__tm\\+-J {
  float: right;
  width: 100%;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  #viewShowAttendee_dashboardcont2__vogPP {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/shows/viewShowAttendee.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AAxlCI;EACI,eAAA;EACA,mBAAA;AA2lCR;AAzlCI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AA2lCR;;AAtlCA;EACI;IACI,wBDoEI;ICnEJ,UDoEG;ICnEH,kBAAA;IACA,aD4DW;EC6hCjB;AACF","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.indexdiv{\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n    .exportsection{\n        float: right;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n}\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `viewShowAttendee_dashboard__OubQU`,
	"dashboardContain": `viewShowAttendee_dashboardContain__YSuhA`,
	"bodythemedark": `viewShowAttendee_bodythemedark__y67m-`,
	"cont2": `viewShowAttendee_cont2__Y6PTs`,
	"top_header": `viewShowAttendee_top_header__hhkIX`,
	"top_header_inner": `viewShowAttendee_top_header_inner__QB2Wu`,
	"subLink": `viewShowAttendee_subLink__kTzjV`,
	"cst_vendr": `viewShowAttendee_cst_vendr__GuivX`,
	"form-control": `viewShowAttendee_form-control__PV8VC`,
	"footer": `viewShowAttendee_footer__XXOdA`,
	"bodythemelight": `viewShowAttendee_bodythemelight__SLZWi`,
	"bodythemeNew": `viewShowAttendee_bodythemeNew__PInKf`,
	"headerthemelight": `viewShowAttendee_headerthemelight__B0jZe`,
	"headerthemedark": `viewShowAttendee_headerthemedark__c+SVE`,
	"menuthemelight": `viewShowAttendee_menuthemelight__MMk8D`,
	"menuthemedark": `viewShowAttendee_menuthemedark__T6l2Z`,
	"menulinklight": `viewShowAttendee_menulinklight__tmm9z`,
	"menulinkdarkSelected": `viewShowAttendee_menulinkdarkSelected__BQgXI`,
	"menulinklightSelected": `viewShowAttendee_menulinklightSelected__pyfaJ`,
	"menulinkdark": `viewShowAttendee_menulinkdark__1C4Gn`,
	"sub_arrow": `viewShowAttendee_sub_arrow__j3C48`,
	"headinglight": `viewShowAttendee_headinglight__rsVcY`,
	"headingdark": `viewShowAttendee_headingdark__ZzRIh`,
	"searchboxlight": `viewShowAttendee_searchboxlight__POzdI`,
	"searchboxdark": `viewShowAttendee_searchboxdark__gS5qQ`,
	"tableheadlight": `viewShowAttendee_tableheadlight__4BwEe`,
	"tableheaddark": `viewShowAttendee_tableheaddark__zX3vr`,
	"table": `viewShowAttendee_table__uMnnr`,
	"table-borderless": `viewShowAttendee_table-borderless__jLig5`,
	"left-section": `viewShowAttendee_left-section__4oRWs`,
	"tablebodylight": `viewShowAttendee_tablebodylight__BxXi1`,
	"tablebodydark": `viewShowAttendee_tablebodydark__lFMm8`,
	"paginationlight": `viewShowAttendee_paginationlight__CN8Nx`,
	"paginationdark": `viewShowAttendee_paginationdark__q2zsX`,
	"formthemelight": `viewShowAttendee_formthemelight__nxrtL`,
	"formthemedark": `viewShowAttendee_formthemedark__ykxKM`,
	"viewformlight": `viewShowAttendee_viewformlight__PWXwx`,
	"permissionboxlight": `viewShowAttendee_permissionboxlight__N1XXM`,
	"permissionboxdark": `viewShowAttendee_permissionboxdark__uJeAt`,
	"errormsgclr": `viewShowAttendee_errormsgclr__zmwB8`,
	"graphclrlight": `viewShowAttendee_graphclrlight__tRzXZ`,
	"graphclrdark": `viewShowAttendee_graphclrdark__3oRPz`,
	"card1bglight": `viewShowAttendee_card1bglight__WWivJ`,
	"card1bgdark": `viewShowAttendee_card1bgdark__2Npk4`,
	"card2bglight": `viewShowAttendee_card2bglight__YBBy3`,
	"card2bgdark": `viewShowAttendee_card2bgdark__EXlv+`,
	"card3bglight": `viewShowAttendee_card3bglight__Bqb3D`,
	"card3bgdark": `viewShowAttendee_card3bgdark__Oljbx`,
	"card4bglight": `viewShowAttendee_card4bglight__Vr2co`,
	"card4bgdark": `viewShowAttendee_card4bgdark__uYbgd`,
	"actionbtnlight": `viewShowAttendee_actionbtnlight__wU1jy`,
	"actionbtndark": `viewShowAttendee_actionbtndark__oWKf3`,
	"profiledropdownlight": `viewShowAttendee_profiledropdownlight__qyYdY`,
	"profiledropdowndark": `viewShowAttendee_profiledropdowndark__sVogl`,
	"settingsection": `viewShowAttendee_settingsection__UmfF7`,
	"addform": `viewShowAttendee_addform__iQw0O`,
	"savebtn": `viewShowAttendee_savebtn__G281V`,
	"profile_conatiner": `viewShowAttendee_profile_conatiner__6lyeu`,
	"ag-theme-alpine": `viewShowAttendee_ag-theme-alpine__b5xZt`,
	"ag-row": `viewShowAttendee_ag-row__nGEJd`,
	"formbtn": `viewShowAttendee_formbtn__3V50I`,
	"resetbtn": `viewShowAttendee_resetbtn__4EdCc`,
	"addBtn": `viewShowAttendee_addBtn__lGgV1`,
	"addDltBtn": `viewShowAttendee_addDltBtn__rAMSG`,
	"addbtnlight": `viewShowAttendee_addbtnlight__Jztmm`,
	"addbtndark": `viewShowAttendee_addbtndark__qSriy`,
	"cust_addBtn": `viewShowAttendee_cust_addBtn__7GBuy`,
	"deleteBtn": `viewShowAttendee_deleteBtn__yFSe8`,
	"confirmBtn": `viewShowAttendee_confirmBtn__iK+be`,
	"delPopContainer": `viewShowAttendee_delPopContainer__mQrXD`,
	"modal-body": `viewShowAttendee_modal-body__cynrs`,
	"delet_icon": `viewShowAttendee_delet_icon__D8Q0f`,
	"arrowback": `viewShowAttendee_arrowback__r0c6F`,
	"drpdwn_btn": `viewShowAttendee_drpdwn_btn__opyvB`,
	"empname": `viewShowAttendee_empname__owAlU`,
	"navitemli": `viewShowAttendee_navitemli__Mpdhb`,
	"tabnavli": `viewShowAttendee_tabnavli__S9HvC`,
	"settingsgeneral": `viewShowAttendee_settingsgeneral__QHE2i`,
	"settingslinks": `viewShowAttendee_settingslinks__qAudI`,
	"dropdown_menu_contain": `viewShowAttendee_dropdown_menu_contain__lvU5r`,
	"dropdown_item": `viewShowAttendee_dropdown_item__gaxol`,
	"profile_arrrow_dwn": `viewShowAttendee_profile_arrrow_dwn__0Wof1`,
	"dateinputbox1": `viewShowAttendee_dateinputbox1__9ob4k`,
	"modal-content": `viewShowAttendee_modal-content__V+FXL`,
	"larg_model": `viewShowAttendee_larg_model__YSDn3`,
	"modal-dialog": `viewShowAttendee_modal-dialog__4px-z`,
	"modal-header": `viewShowAttendee_modal-header__qPxNN`,
	"btn-primary": `viewShowAttendee_btn-primary__oFnhs`,
	"form-select": `viewShowAttendee_form-select__ViUc9`,
	"CustomTable_tableheadlight__HuHZw": `viewShowAttendee_CustomTable_tableheadlight__HuHZw__SVAHo`,
	"CustomTable_tableheaddark__nwqb4": `viewShowAttendee_CustomTable_tableheaddark__nwqb4__YVhg9`,
	"sectionright": `viewShowAttendee_sectionright__MGMNH`,
	"exer_modal_contain": `viewShowAttendee_exer_modal_contain__Aqb1m`,
	"active_show_outer": `viewShowAttendee_active_show_outer__L0WCQ`,
	"active_show_inner": `viewShowAttendee_active_show_inner__8YWmA`,
	"act_box_img": `viewShowAttendee_act_box_img__Hd3xs`,
	"act_box_cnt": `viewShowAttendee_act_box_cnt__0kKBX`,
	"act_box_bdg": `viewShowAttendee_act_box_bdg__RZokO`,
	"sold": `viewShowAttendee_sold__-BMAE`,
	"timezone_code_pill": `viewShowAttendee_timezone_code_pill__7KoAw`,
	"attent_details_row1": `viewShowAttendee_attent_details_row1__EvLDo`,
	"attent_details": `viewShowAttendee_attent_details__3qH0V`,
	"attent_details_inner": `viewShowAttendee_attent_details_inner__GPV1e`,
	"attent_details_inner_l": `viewShowAttendee_attent_details_inner_l__uJDA3`,
	"attent_details_inner_r": `viewShowAttendee_attent_details_inner_r__yKnJK`,
	"attent_details_row": `viewShowAttendee_attent_details_row__Fr23I`,
	"attent_details_row_box": `viewShowAttendee_attent_details_row_box__tgf6U`,
	"attent_details_row_last": `viewShowAttendee_attent_details_row_last__rQlip`,
	"interesting_fact": `viewShowAttendee_interesting_fact__4vT9h`,
	"showbox_sec": `viewShowAttendee_showbox_sec__GLDuz`,
	"show_box_main": `viewShowAttendee_show_box_main__hpyFI`,
	"show_box": `viewShowAttendee_show_box__IhquG`,
	"no_show_box": `viewShowAttendee_no_show_box__1n0lz`,
	"attent_flex": `viewShowAttendee_attent_flex__9i9cQ`,
	"indexdiv": `viewShowAttendee_indexdiv__j9uA6`,
	"addheading": `viewShowAttendee_addheading__Vbo81`,
	"exportsection": `viewShowAttendee_exportsection__tm+-J`,
	"dashboardcont2": `viewShowAttendee_dashboardcont2__vogPP`
};
export default ___CSS_LOADER_EXPORT___;
